import * as React from 'react';
import type {UserType} from '../store/user';


import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { View, Text, rem, ResponsiveView } from '../libs/WebComponents';
import welkom_sign from './../svgs/welkom-sign.svg';
import {useUserStore} from '../store/user';
import { useGrowlStore } from './../store/growls';
import {createUser} from './../api/api-user';
import { GroupType } from '../App';

const PageSignup = (props: {index: number, goTo: Function, prevPage: Function, group: GroupType}) => {

   const {firstname, role, role2, role_other, token, group_id, updateFirstname, updateRole, updateRole2, updateRoleOther, updateToken} = useUserStore();
   const [errorFirstname, setErrorFirstname] = React.useState(false);
   const [errorRole, setErrorRole] = React.useState(false);
   const [errorOtherRole, setErrorOtherRole] = React.useState(false);
   const [loading, setLoading] = React.useState(false);
   const [showSecondRole, setShowSecondRole] = React.useState(false);
   const [showOtherRole, setShowOtherRole] = React.useState(false);
   const [firstRole, setFirstRole] = React.useState(role);
   const [secondRole, setSecondRole] = React.useState(role2);
   const { addGrowl } = useGrowlStore();

   const roles = props.group.visitor_roles;

   const createNewUser = async(user: {firstname: UserType['firstname'], role: UserType['role'], role2: UserType['role2'], role_other: UserType['role_other'], group_id: UserType['group_id']})=>{
      try {
         const res = await createUser(user);
         updateToken(res.token);

      }catch(err)
      {
         addGrowl({type:'danger', message:'Oops error creating user!', dismissible:true, autoclose:true});
         console.warn(err);
      }
   };

   const _changeRole = (e: any)=>{
      setFirstRole(e.target.value);

      setShowOtherRole(e.target.value ==='other');
      if (e.target.value ==='other')
      {
         return;
      }
      if (e.target.value !=='' && e.target.value !=='unknown')
      {
         setShowSecondRole(true);
      }else{
         setShowSecondRole(false);
         setSecondRole('');
      }
   };

   const _updateRole2 = (e: any)=>{
      setSecondRole(e.target.value)
   }


   const submitUserForm = async(e: any)=>{
      e.preventDefault();
      const user_firstname: UserType['firstname'] = e.target.user_firstname ? String(e.target.user_firstname.value): '';
      const user_role: UserType['role'] = e.target.user_role && e.target.user_role.value ? String(e.target.user_role.value):'unknown';
      const user_role2: UserType['role2'] = e.target.user_role2 && e.target.user_role2.value ? String(e.target.user_role2.value):'';
      const user_role_other: UserType['role_other'] = e.target.user_role_other ? String(e.target.user_role_other.value): '';
      const user_error = user_firstname === '' || user_firstname.length < 3;
      const role_error = user_role === 'unknown' && roles.length>0;
      const other_role_error = user_role === 'other' && user_role_other === '';
      setErrorFirstname(user_error );
      setErrorRole(role_error );
      setErrorOtherRole(other_role_error);
      updateFirstname(user_firstname);
      updateRole(user_role);
      updateRole2(user_role2);
      updateRoleOther(user_role_other);

      if (!role_error && !user_error && !other_role_error)
      {
         setLoading(true);
         await createNewUser({firstname:user_firstname, role:user_role, role2:user_role2,role_other:user_role_other, group_id:group_id});
         setLoading(false);
      }
   };

   React.useEffect(()=>{
      if (token){
         props.goTo(props.index+1);
      }
   },[token]);


   return (
      <View className={'page'}>
      <Form onSubmit={submitUserForm} name="user-form" autoComplete="off">
         {token?<View style={{flex:1,justifyContent:'center',alignItems:'center',paddingTop:'12vh'}}>
            <Text>Je bent al aangemeld.</Text>
         </View>:(
         <Container style={{paddingTop:rem(3),marginBottom:rem(10)}}>
            <Row className="justify-content-center">
               <Col className="col-12 d-flex col-lg-4 order-lg-1 order-2 align-items-end">
                  <Form.Group className={`mb-4 ${errorFirstname?'is-invalid':''}`} style={{width:'100%'}}>
                     <Form.Label className="mx-4">Hoe mogen we jou noemen?</Form.Label>
                     <Form.Control style={{ display: 'inline' }} name="user_firstname" type="text" placeholder="Schrijf jouw naam" defaultValue={firstname}/>
                  </Form.Group>
               </Col>
               <Col className="col-10 col-lg-4 order-lg-2 order-1 text-center">
                  <ResponsiveView style={{width:rem(15), marginLeft:'auto',marginRight:'auto',xs:{width:rem(12)}}}><img src={welkom_sign} /></ResponsiveView>
                  <Text h5 className="ph-4">
                     Fijn dat je mee doet!
                  </Text>
               </Col>
            </Row>
            <Row className="justify-content-center">
               {roles && roles.length>0?<Col className="col-12 col-lg-4">
                  <Form.Group className={`mb-4 ${errorRole?'is-invalid':''}`}>
                     <Form.Label className="mx-4">Welke rol(len) heb jij?</Form.Label>
                     <Form.Select aria-label="Kies" name="user_role" value={firstRole} onChange={_changeRole}>
                        <option value="unknown">- Kies jouw rol -</option>
                        {roles.map((r)=><option key={r.value} value={r.value}>{r.label}</option>)}
                     </Form.Select>
                  </Form.Group>
                  {showOtherRole?<Form.Group className={`mb-4 ${errorOtherRole?'is-invalid':''}`} style={{width:'100%'}}>
                     <Form.Control style={{ display: 'inline' }} name="user_role_other" type="text" placeholder="" defaultValue={role_other}/>
                  </Form.Group>:null}
                  <Form.Group className={`mb-4`} style={{opacity:showSecondRole?1:.3}}>
                     <Form.Select aria-label="Kies" name="user_role2" value={secondRole} disabled={!showSecondRole} onChange={_updateRole2}>
                        <option value="unknown">- Eventueel tweede rol -</option>
                        {roles.filter(r=>r.value!==firstRole && r.value !== 'other').map((r)=><option key={r.value} value={r.value}>{r.label}</option>)}
                     </Form.Select>
                  </Form.Group>
               </Col>:<Col className="col-12 my-4" />}
               <Col className="col-12 d-flex col-lg-4 justify-content-center align-items-end">
                  <Form.Group className="mb-4">
                     <Button variant="success" type="submit" disabled={loading} style={{minWidth:rem(20)}}>
                        {loading?'Verzenden':'Starten'}
                     </Button>
                  </Form.Group>
               </Col>
            </Row>
         </Container>)}
      </Form>
   </View>
   );
}

export default React.memo(PageSignup);

